
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, NgZone, OnDestroy } from '@angular/core';
declare const google: any;

@Component({
  selector: 'app-place-autocomplete',
  styleUrls: ['./place-autocomplete.component.scss'],
  templateUrl: './place-autocomplete.component.html',
})
export class PlaceAutocompleteComponent implements OnInit, OnDestroy {
  @ViewChild('map', { static: null }) mapElement: ElementRef;
  @Input() addressType: string;
  @Input() submitted: boolean;
  @Input() parentForm;
  // @Output() setAddress: EventEmitter<any> = new EventEmitter();

  map: any;
  latitude: any;
  longitude: any;
  autocompleteInput = '';
  places: any = [];
  autocompleteService: any;
  placesService: any;
  autocomplete;
  constructor(private zone: NgZone) {
    //
  }
  ngOnInit() {
    this.places = [];
    this.initialize();
    if (this.parentForm.value.user_outlet_location_attributes.formatted_address) {
      this.autocompleteInput = this.parentForm.value.user_outlet_location_attributes.formatted_address;
    }
    // console.log(this.parentForm);

  }

  initialize() {
    // console.log(navigator);

    // navigator.geolocation.getCurrentPosition((position) => {

    //   this.latitude = position.coords.latitude;
    //   this.longitude = position.coords.longitude;
    //   const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    //   const mapOptions = {
    //     center: latLng,
    //     zoom: 15
    //   };

    //   // this.autocompleteService = new google.maps.places.AutocompleteService;

    //   this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    //   // this.placesService = new google.maps.places.PlacesService(this.map);
    // });
  }
  ngAfterViewInit() {
    this.autocomplete = new google.maps.places.Autocomplete(this.mapElement.nativeElement,
      {
        types: ['establishment', 'geocode']  // 'establishment' / 'address' / 'geocode'
      });
    // google.maps.event.trigger(this.autocomplete, 'place_changed');
    this.autocomplete.addListener('place_changed', () => {
      this.zone.run(() => {
        let place = this.autocomplete.getPlace();
        this.selectPlace(place);
      }
      )
    });


    document.getElementsByTagName('ngb-modal-window')[0].addEventListener('scroll', (event) => {

      if (document.getElementsByClassName('pac-container')[0] && this.mapElement.nativeElement) {
        document.getElementsByClassName('pac-container')[0]['style'].top = (this.mapElement.nativeElement.getBoundingClientRect().top + window.scrollY + 40) + "px";
      }

    });
  }
  searchPlace() {
    if (this.autocompleteInput === '') {
      this.places = [];
      this.parentForm.get('user_outlet_location_attributes').setValue({
        name: "",
        city: "",
        state: "",
        country: '',
        lat: "",
        long: "",
        formatted_address: "",
        zip_code: ""
      });
      return;
    }
    else {
      const config = {
        input: this.autocompleteInput,
        types: ['establishment', 'geocode']
      };
      // console.log(this.autocompleteService.getPlacePredictions(config));
      // const place = this.autocomplete.getPlace();
      // console.log(place);
      // google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
      //   const place = this.autocomplete.getPlace();
      //   this.getAddress(place);
      // });
      // this.getAddress(place);
      // this.autocompleteService.getPlacePredictions(config, (predictions, status) => {
      //   if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
      //     this.places = [];
      //     predictions.forEach((prediction) => {
      //       const obj = {
      //         address: '',
      //         place: prediction.terms[0].value,
      //         prediction
      //       };
      //       const address = [];
      //       for (let index = 1; index < prediction.terms.length; index++) {
      //         address.push(prediction.terms[index].value);
      //       }
      //       if (address.length > 0) {
      //         obj.address = address.join();
      //       }
      //       this.places.push(obj);
      //     });
      //   }
      // });
    }
  }
  selectPlace(item) {
    this.places = [];
    let address = {
      name: "",
      city: "",
      state: "",
      country: '',
      lat: "",
      long: "",
      formatted_address: "",
      zip_code: ""
    };
    address['lat'] = item.geometry.location.lat();
    address['long'] = item.geometry.location.lng();
    if (item.formatted_address)
      this.autocompleteInput = item.formatted_address;
    const search = ['postal_code', 'country', 'administrative_area_level_1', 'administrative_area_level_2']
    if (item.address_components) {
      let name = '';
      item.address_components.forEach(element => {
        if (search.includes(element.types[0])) {
          if (element.types[0] == 'country') {
            address['country'] = element.long_name;
          } else if (element.types[0] == 'administrative_area_level_1') {
            address['state'] = element.long_name;
          } else if (element.types[0] == 'administrative_area_level_2') {
            address['city'] = element.long_name;
          } else if (element.types[0] == 'postal_code') {
            address['zip_code'] = element.long_name
          }
        } else {
          name = name + element.long_name + ' ';
        }
      });
      address['name'] = name;
    }
    address['formatted_address'] = item.formatted_address;
    this.parentForm.get('user_outlet_location_attributes').setValue(address);
  }

  preventSubmit(e) {
    if (e.keyCode == 13) {
      e.preventDefault();
    }
  }

  ngOnDestroy() {

    if (document.getElementsByClassName('pac-container')[0]) {
      document.getElementsByClassName('pac-container')[0].remove()
    }
  }

}
